// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eu-nav-bar{width:100%;height:54px;display:flex;flex-flow:row;box-shadow:0 1px 10px 0 #ddd;box-shadow:0 1px 10px 0 var(--color-gray-gainsboro,#ddd);align-items:center}.eu-nav-bar.fixed{position:fixed;top:0;left:0}.eu-nav-bar>.eu-nav-bar-left{margin-left:16px;cursor:pointer}.eu-nav-bar>.eu-nav-bar-right{margin-right:16px;cursor:pointer}.eu-nav-bar>.eu-nav-bar-middle{margin:0 16px;flex-grow:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
